import React from 'react';
import { Stack } from 'expo-router';
import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export default function RootLayout() {
  return <Stack screenOptions={SCREEN_OPTIONS} />;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const SCREEN_OPTIONS = {
  headerShown: false,
  title: 'sweetgreen',
  headerTitleAlign: 'center' as const,
  headerStyle: { backgroundColor: theme.colors.APP_BACKGROUND },
};
